import type {SocialLinkType, LinkType} from '@rambler-components/footer'

export enum CAPTCHA_SITEKEY {
  reCaptchaV2 = '6LeHeSkUAAAAANUvgxwQ6HOLXCT6w6jTtuJhpLU7',
  hCaptcha = '322e5e22-3542-4638-b621-fa06db098460'
}

export const SENTRY_DSN =
  'https://eb2bcf79560dbc7a12bf1ca03dcc0421@sentry-saas.rambler-co.ru/145'

export const SENTRY_IGNORE_ERROR = [
  -11,
  -4000,
  -2000,
  -2002,
  -3000,
  'need session',
  'invalid login',
  'rate limit exceed',
  'api does not respond'
]

export const MENU_LINKS: LinkType[] = [
  {
    url: 'https://help.rambler.ru/id/',
    label: 'Помощь'
  },
  {
    url: 'https://help.rambler.ru/feedback/id/',
    label: 'Обратная связь'
  },
  {
    url: 'https://help.rambler.ru/legal/id/',
    label: 'Условия использования'
  },
  {
    url: 'https://help.rambler.ru/legal/1142/',
    label: 'Политика конфиденциальности'
  }
]

export const SOCIAL_LINKS: SocialLinkType[] = [
  {
    code: 'vk',
    url: 'https://vk.com/rambler'
  },
  {
    code: 'ok',
    url: 'https://ok.ru/rambler'
  },
  {
    code: 'tg',
    url: 'https://t.me/news_rambler'
  }
]
